import { useGetProspectQuery } from "@apis/prospects/useProspects"
import { useDrawer } from "@contexts/DrawerContext"
import { useHasPermissions } from "@hooks/useHasPermissions"
import { ProspectForm } from "./ProspectForm/ProspectForm"
import { AccountContactPreferencesForm } from "@components/AccountNew/AccountContactPreferencesForm/AccountContactPreferencesForm"
import AccountCasesContainer from "@components/account/accountCases/AccountCasesContainer"

export const useProspectTitleSerializer = (prospect_guid: string) => {
  const getProspectQuery = useGetProspectQuery(prospect_guid)
  const { roleCanOpenCase } = useHasPermissions()
  const { openDrawer } = useDrawer()

  const data = {
    buttonItems: [
      {
        label: "Edit Prospect",
        onClick: () =>
          openDrawer(
            <ProspectForm prospect_guid={prospect_guid} />,
            "Edit Prospect",
          ),
      },
      {
        label: "Contact Preferences",
        onClick: () =>
          openDrawer(
            <AccountContactPreferencesForm prospect_guid={prospect_guid} />,
            "Update Contact Preferences",
          ),
      },
      {
        label: "Cases",
        onClick: () =>
          openDrawer(
            <AccountCasesContainer
              prospect={getProspectQuery.data}
              account={null}
            />,
            "Cases",
          ),
        permissions: roleCanOpenCase,
      },
    ],
    prospectFullName: (() => {
      const firstName = getProspectQuery.data?.first_name
      const lastName = getProspectQuery.data?.last_name

      return firstName && lastName
        ? `${firstName} ${lastName}`
        : firstName || lastName || "Prospect"
    })(),
    headerItems: [
      {
        title: { content: "Prospect GUID:" },
        value: {
          content: getProspectQuery.data?.prospect_guid,
          isPending: getProspectQuery.isPending,
        },
      },
      {
        title: { content: "Phone:" },
        value: {
          content: getProspectQuery.data?.primary_phone,
          isPending: getProspectQuery.isPending,
        },
      },
      {
        title: { content: "Email:" },
        value: {
          content: getProspectQuery.data?.email?.email_address,
          isPending: getProspectQuery.isPending,
        },
      },
    ],
    prospect_data: getProspectQuery.data,
  }

  return {
    data,
    isError: getProspectQuery.isError,
    isPending: getProspectQuery.isPending,
    error: getProspectQuery.error,
  }
}
